import { render } from "./VendorPaymentsList.vue?vue&type=template&id=43e3966c"
import script from "./VendorPaymentsList.vue?vue&type=script&lang=js"
export * from "./VendorPaymentsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__